import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(auth)/account/my-tickets/page.tsx");
